// Read-only presentation of quote-v4 sources. No legacy pricing or grouping runs here.
const sourceId = (value, key) => Number(value && (value[key] || value.id) || 0)
const identity = item => String(item.line_id || item.id || '')
export const previewMoney2 = value => value === null || value === undefined ? '—' : '$' + Number(value).toFixed(2)

export function pdfPreviewSections2 (form, quote) {
  const components = quote.preview_components || []
  return (form.order_items || []).map(item => {
    const owner = identity(item)
    const rows = components.filter(row => row.scope === 'item' && String(row.owner) === owner)
    const merchandise = rows.find(row => row.type === 'merchandise')
    const decoration = rows.find(row => row.type === 'decoration')
    const sources = (merchandise && merchandise.sources || []).slice()
    const colors = []
    function addColor (color, suffix = '', parentSourceColorId = null) {
      // QuotePayloadNormalizer folds inner sizes into the parent color's source bucket.
      const sourceColorId = parentSourceColorId === null ? (sourceId(color, 'color_id') || sourceId(color.color, 'color_id')) : parentSourceColorId
      const sizes = (color.sizes || []).filter(size => Number(size.quantity) > 0).map(size => {
        const key = [item.program_id || (item.program_info || {}).program_id, item.style_id || (item.style_info || {}).style_id, sourceColorId, sourceId(size, 'size_id') || sourceId(size.size, 'size_id')].join(':')
        const index = sources.findIndex(source => source.source === key && Number(source.quantity) === Number(size.quantity))
        const source = index < 0 ? null : sources.splice(index, 1)[0]
        return { ...size, unit_price: source ? source.unit_rate : null, extension: source ? source.extension : null }
      })
      if (sizes.length) colors.push({ ...color, sizes, color_label: (color.color_name || '') + (color.customer_color_name ? ' (' + color.customer_color_name + ')' : '') + suffix })
      ;(color.inner_colors || []).forEach((inner, index) => addColor(inner, ' - ' + (index + 2), sourceColorId))
    }
    ;(item.order_item_colors || []).forEach(color => addColor(color))
    const locations = (item.order_item_locations || []).map(location => {
      const key = String(location.decoration_key || location.id || location.location_reference || '')
      const source = (decoration && decoration.sources || []).find(row => String(row.location_reference) === key)
      return { ...location, quantity: source ? source.quantity : null, cost: source ? source.base_unit_amount : null, extension: source ? source.base_extension : null }
    })
    return {
      key: owner, item, colors, merchandise, decoration,
      order_item_locations: locations,
      accessories: ['band', 'rope', 'leather'].filter(type => colors.some(color => color[type])),
      additionalLocations: rows.filter(row => row.type === 'additional_locations'),
      adjustments: rows.filter(row => !['merchandise', 'decoration', 'additional_locations'].includes(row.type))
    }
  })
}
